import useCart from 'modules/cart/util/use-cart';
import React from 'react';
import Column from 'shared/components/column';
import Row from 'shared/components/row';
import {MediumText, RegularText, SemiBoldText} from 'shared/components/text';
import Loading from 'shared/migration-components/loading';
import toBrl from 'shared/util/to-brl';

const CartSummary: React.FC = () => {
  const {
    cart,
    total,
    deliveryPrice,
    deliveryPriceQuery,
    discount,
    freeDeliveryThreshold,
  } = useCart();

  const {coupon, balance} = cart!;

  return (
    <Column gap={10}>
      <SemiBoldText size="medium">Resumo do pedido</SemiBoldText>
      <Row justifyContent="space-between">
        <RegularText>Subtotal</RegularText>
        <MediumText>{toBrl(total)}</MediumText>
      </Row>
      {coupon && (
        <Row justifyContent="space-between">
          <RegularText>Desconto</RegularText>
          <MediumText>- {toBrl(discount)}</MediumText>
        </Row>
      )}
      {!!balance && (
        <Row justifyContent="space-between">
          <RegularText>Saldo da carteira</RegularText>
          <MediumText>- {toBrl(balance)}</MediumText>
        </Row>
      )}
      <Row justifyContent="space-between">
        <RegularText>Taxa de entrega</RegularText>
        {!deliveryPriceQuery.data?.freeDelivery &&
          !freeDeliveryThreshold &&
          !isNaN(deliveryPrice) &&
          !deliveryPriceQuery.isLoading && (
            <MediumText>{toBrl(deliveryPrice)}</MediumText>
          )}
        {(deliveryPriceQuery.data?.freeDelivery || !!freeDeliveryThreshold) && (
          <MediumText color="green">Grátis</MediumText>
        )}
        {deliveryPriceQuery.isLoading && <Loading />}
      </Row>
      <Row justifyContent="space-between">
        <SemiBoldText>Total</SemiBoldText>
        <SemiBoldText>
          {toBrl(
            total -
              discount -
              (balance ?? 0) +
              (deliveryPriceQuery.data?.freeDelivery || freeDeliveryThreshold
                ? 0
                : deliveryPrice),
          )}
        </SemiBoldText>
      </Row>
    </Column>
  );
};

export default CartSummary;
